// Please update the linked Confluence page before changing the list of Botify PageWorkers paths
// https://johnlewispartnership.atlassian.net/wiki/spaces/WD/pages/1249050674/Botify+PageWorker+Script+Injection+Rules

export const botifyPageWorkersPaths = [
  /^\/$/,
  /^\/ecom\/shop\/browse\/groceries(\/.*)?$/,
  /^\/ecom\/shop\/browse\/entertaining(\/.*)?$/,
  /^\/ecom\/shop\/browse\/offers(\/.*)?$/,
  /^\/ecom\/products(\/.*)?$/,
  /^\/ecom\/shop\/offers(\/.*)?$/,
  /^\/ecom\/shop\/featured(\/.*)?$/,
  /^\/ecom\/recipes(\/.*)?$/,
  /^\/ecom\/recipe(\/.*)?$/,
  /^\/ecom\/content(\/.*)?$/,
];
